exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-tabs--line .van-tabs__wrap {\n  height: 1.306667rem;\n}\n.van-tab {\n  font-size: 0.48rem;\n  height: 1.306667rem;\n  line-height: 1.306667rem;\n}\n.van-tab__text1 {\n  height: 1.306667rem;\n}\n.van-ellipsis {\n  margin-top: 0.306667rem;\n  font-size: 0.48rem;\n  font-family: PingFangSC-Medium, PingFang SC;\n  font-weight: 500;\n  line-height: 0.666667rem;\n}", ""]);

// exports
